import { numberMinMax } from './numberMinMax'

/**
 * Validate for duration in hours
 */
export const isValidDurationInHours = numberMinMax(0.0, 24.0)
